import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, TextField, Button, MenuItem } from "@mui/material";
import TravelerDetails from "./TravelerDetails"; // your traveler form component
import MealDrawer from "./MealDrawer"; // your meal selection drawer component
import axios from "axios";
import MultiBaggageDrawer from "./MultiBaggageDrawer";

const seatOptions = ["Window", "Middle", "Aisle"];
const mealOptions = ["Vegetarian", "Non-Vegetarian", "Vegan", "No Meal"];
const baggageOptions = ["15 KG", "20 KG", "30 KG", "40 KG"];

// Dummy countries list for TravelerDetails
const countries = [
    { code: "US", name: "United States", nationality: "American" },
    { code: "IN", name: "India", nationality: "Indian" },
    { code: "GB", name: "United Kingdom", nationality: "British" },
    // add more as needed
];

// Dummy mealDynamicData for example (replace with your actual data)
const mealDynamicData = [
    { code: "veg", label: "Vegetarian" },
    { code: "nonveg", label: "Non-Vegetarian" },
    { code: "vegan", label: "Vegan" },
    { code: "nomeal", label: "No Meal" },
];

const MultiCityBooking = () => {
    const { state } = useLocation();
    const { segment, searchDetails } = state || {};
    const [baggageDrawerOpen, setBaggageDrawerOpen] = useState(false);
    const [selectedBaggage, setSelectedBaggage] = useState({});
    const [step, setStep] = useState(1);
    const [travelerDetails, setTravelerDetails] = useState([]);
    const [formData, setFormData] = useState({
        baggage: segment?.Baggage || "30 KG", // baggage only here now
    });
    const [mealDrawerOpen, setMealDrawerOpen] = useState(false);
    const [selectedMeals, setSelectedMeals] = useState([]);
    const [countries, setCountries] = useState([]); // to hold fetched countries
    const baggageData = baggageOptions.map(option => ({ label: option, value: option }));
    const handleOpenBaggageDrawer = () => {
        setBaggageDrawerOpen(true);
    };
    console.log("segment", segment);
    console.log("searchDetails", searchDetails);
    useEffect(() => {
        axios
            .get("https://restcountries.com/v3.1/all")
            .then((response) => {
                const countryData = response.data.map((country) => ({
                    name: country.name.common,
                    code: country.cca2,
                    nationality: country.demonyms?.eng?.f || "N/A",
                }));

                const sortedCountries = countryData.sort((a, b) =>
                    a.name.localeCompare(b.name)
                );
                setCountries(sortedCountries);
            })
            .catch((error) => {
                console.error("Error fetching countries:", error);
            });
    }, []);

    useEffect(() => {
        if (step === 3) {
            setMealDrawerOpen(true);
        }
    }, [step]);

    if (!segment || !searchDetails) {
        return <Typography>No booking data available.</Typography>;
    }

    // Step 2 baggage change handler
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Step 1: Traveler form submit
    const handleTravelerFormSubmit = (data) => {
        setTravelerDetails(data);
        setStep(2);
    };

    // Step 2: Baggage submit
    const handleBaggageSubmit = (e) => {
        e.preventDefault();
        if (!formData.baggage) {
            alert("Please select baggage.");
            return;
        }
        setStep(3);
    };

    // When done selecting baggage
    const handleBaggageDone = (finalSelectedBaggage) => {
        setSelectedBaggage(finalSelectedBaggage);
        setBaggageDrawerOpen(false);
        setStep(3); // proceed to meal selection step
    };

    // Step 3: Meal done handler remains unchanged
    const handleMealDone = (selectedMealsWithTraveler) => {
        setSelectedMeals(selectedMealsWithTraveler);
        setMealDrawerOpen(false);
        alert("Meal selection done! You can proceed.");
        // proceed further or submit final data here
    };

    return (
        <Box
            sx={{
                width: { xs: "90%", sm: 500, md: 600, lg: 700 },
                mx: "auto",
                mt: 4,
                p: 3,
                border: "1px solid #ccc",
                borderRadius: 2,
            }}
        >
            <Typography variant="h6" gutterBottom>
                Booking for Flight {segment.Airline.FlightNumber}
            </Typography>
            {/* Flight info here... */}

            {/* Step 1: Traveler Details */}
            {step === 1 && (
                <TravelerDetails
                    type="traveler"
                    count={searchDetails.travelers || 1}
                    countries={countries}
                    passportRequired={true}
                    onFormSubmit={handleTravelerFormSubmit}
                />
            )}

            {/* Step 2: Baggage selection */}
            {step === 2 && (
                <>
                    <Button variant="contained" onClick={handleOpenBaggageDrawer} fullWidth>
                        Select Baggage
                    </Button>

                    <MultiBaggageDrawer
                        open={baggageDrawerOpen}
                        onClose={() => setBaggageDrawerOpen(false)}
                        onOpen={() => setBaggageDrawerOpen(true)}
                        baggageData={baggageData} // Pass your baggage data here
                        selectedBaggage={selectedBaggage}
                        setSelectedBaggage={setSelectedBaggage}
                        passengerCount={travelerDetails.length}
                        travelerDetails={travelerDetails}
                        onDone={handleBaggageDone}
                    />
                </>
            )}


            {/* Step 3: Meal selection */}
            {step === 3 && (
                <>
                    <Button
                        variant="contained"
                        sx={{ mb: 2 }}
                        onClick={() => setMealDrawerOpen(true)}
                    >
                        Select Meals
                    </Button>
                    <MealDrawer
                        open={mealDrawerOpen}
                        onClose={() => setMealDrawerOpen(false)}
                        mealDynamicData={mealDynamicData}
                        travelerDetails={travelerDetails}
                        selectedMeals={selectedMeals}
                        updateSelectedMeals={setSelectedMeals}
                        passengerCount={travelerDetails.length}
                        onDone={handleMealDone}
                    />
                </>
            )}
        </Box>
    );
};


export default MultiCityBooking;
